import { API } from "@project/shared"

export const getStaffList = async () => API.get("/instructors")

export const getFacilitySchedules = async (facilityId) =>
  API.get(`/attendance-shift?facilityIds=${facilityId}`)
